import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.css'],
    standalone: false
})
export class TestComponent implements OnInit {
  image: any;
  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
  }

  imageUpload(): void {
    this.dashboardService.imageUpload(this.image, 'fdajfkadsjkjadfadsf', '/profile').subscribe(() => {});
  }

  pickImage(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      this.image = file;
    }
  }
}
